import styled from 'styled-components';

export const ListingBox = styled.div`
  display: flex;
  flex: 1;
  overflow-y: auto;
  position: relative;
  flex-direction: column;
  background-color: #fff;
  z-index: 1;
`;

export const LoadingBox = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  padding-top: 20px;
`;

export const ListingBoxGrid = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(5, 1fr);
  grid-auto-rows: 150px;
  @media (max-width: 2900px) {
    grid-template-columns: repeat(5, 1fr); 
  }
  @media (max-width: 1400px) {
    grid-template-columns: repeat(5, 1fr); 
  }
  @media (max-width: 1200px) {
    grid-template-columns: repeat(4, 1fr); 
  }
  @media (max-width: 950px) {
    grid-template-columns: repeat(3, 1fr); 
  }
  @media (max-width: 700px) {
    grid-template-columns: repeat(2, 1fr); 
  }
  @media (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr); 
  }
  @media (max-width: 450px) {
    grid-template-columns: repeat(1, 1fr); 
  }
`;

export const FilteresBox = styled.div`
  padding: 5px;
  padding-bottom: 0;
`;

export const FilterGenreBox = styled.div`
  font-size: 12px;
  background: #F8941C;
  padding: 4px 8px;
  color: #fff;
  border-radius: 5px;
  display: inline-block;
`;

export const ClearFilter = styled.div`
  cursor: pointer;
  margin-left: 5px;
  display: inline-block;
`;